module.exports = {"search":{"title":"Search","text":"ค้นหา","orderNo":"Order No.","drawingNo":"Drawing No.","customerName":"Customer Name","customerCode":"Customer Code","code":"Code","model":"Model","priority":"Priority","notFound":"Search Not Found","status":"Status","drawingRev":"Rev","coilSize":"Coil Size","pipeType":"Pipe type & Pattern","searchText":"ค้นหา","showLess":"แสดงแบบย่อ","showAll":"แสดงทั้งหมด"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/search.json
// module id = 556
// module chunks = 69